<template>
  <div v-if="input != null">
    <div
      v-for="settingInput in SettingInputs"
      :key="settingInput.setting.Behavior_Setting_Id + 'setting'"
    >
      <p class="mb-0">
        <strong>{{ settingInput.setting.Title }}</strong>
      </p>
      <!-- out of -->
      <div
        v-if="
          input.Score_Template_Input_Type_Id == 1 ||
            (input.Score_Template_Input_Type != null &&
              input.Score_Template_Input_Type.Score_Template_Input_Type_Id == 1)
        "
        class="form-group"
      >
        <label v-bind:for="'outOf' + settingInput.setting.Behavior_Setting_Id"
          >{{ input.Request }} (Out of {{ input.Input_Data.Out_Of }})</label
        >
        <input
          type="number"
          class="form-control"
          v-bind:id="'outOf' + settingInput.setting.Behavior_Setting_Id"
          v-model="settingInput.inputs.find(i => i.order == input.Order).input"
          v-on:blur="
            checkMax(
              settingInput.inputs.find(i => i.order == input.Order),
              input.Input_Data.Out_Of
            )
          "
          v-on:change="inputDataChange(input, settingInput)"
          min="0"
          v-bind:max="input.Input_Data.Out_Of"
          required
        />
      </div>
      <!-- percentage -->
      <div
        v-if="
          input.Score_Template_Input_Type_Id == 2 ||
            (input.Score_Template_Input_Type != null &&
              input.Score_Template_Input_Type.Score_Template_Input_Type_Id == 2)
        "
        class="form-group"
      >
        <label v-bind:for="'score' + settingInput.setting.Behavior_Setting_Id"
          >{{ input.Request }} (Percentage)</label
        >
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            v-bind:id="'score' + settingInput.setting.Behavior_Setting_Id"
            v-model="
              settingInput.inputs.find(i => i.order == input.Order).input
            "
            v-on:change="inputDataChange(input, settingInput)"
            v-on:blur="
              convertToPercentage(
                settingInput.inputs.find(i => i.order == input.Order)
              )
            "
            placeholder="Entering fractions (Ex. 4/5) will convert to a percentage"
            required
          />
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
      </div>
      <!-- Scale -->
      <div
        v-if="
          input.Score_Template_Input_Type_Id == 3 ||
            (input.Score_Template_Input_Type != null &&
              input.Score_Template_Input_Type.Score_Template_Input_Type_Id == 3)
        "
        class="form-group"
      >
        <label class="mr-4">{{ input.Request }}</label>
        <div
          v-for="(scaleValue, index) in $rangeArray(
            input.Input_Data.Min_Value,
            input.Input_Data.Max_Value,
            1
          )"
          :key="index"
          class="d-inline-block"
        >
          <label
            class="btn btn-sm mr-1"
            v-bind:for="
              scaleValue + 'scale' + settingInput.setting.Behavior_Setting_Id
            "
            v-bind:class="{
              'btn-primary':
                settingInput.inputs.find(i => i.order == input.Order).input ==
                scaleValue,
              'btn-outline-primary':
                settingInput.inputs.find(i => i.order == input.Order).input !=
                scaleValue
            }"
          >
            <input
              style="display: none"
              type="radio"
              v-bind:id="
                scaleValue + 'scale' + settingInput.setting.Behavior_Setting_Id
              "
              v-bind:name="
                'scaleInput' + settingInput.setting.Behavior_Setting_Id
              "
              v-bind:value="scaleValue"
              v-model="
                settingInput.inputs.find(i => i.order == input.Order).input
              "
            />{{ scaleValue }}
          </label>
        </div>
      </div>
      <!-- multiple choice -->
      <div
        v-if="
          input.Score_Template_Input_Type_Id == 4 ||
            (input.Score_Template_Input_Type != null &&
              input.Score_Template_Input_Type.Score_Template_Input_Type_Id == 4)
        "
        class="form-group"
      >
        <label>{{ input.Request }}</label>
        <div v-for="choice in input.Input_Data.Choices" :key="choice.Choice">
          <label
            class="btn btn-sm"
            v-bind:for="
              'choice' +
                choice.Choice +
                '-' +
                settingInput.setting.Behavior_Setting_Id
            "
            v-bind:class="{
              'btn-primary':
                settingInput.inputs.find(i => i.order == input.Order).input ==
                choice.Choice,
              'btn-outline-primary':
                settingInput.inputs.find(i => i.order == input.Order).input !=
                choice.Choice
            }"
          >
            <input
              style="display: none"
              type="radio"
              v-bind:name="'choices' + settingInput.setting.Behavior_Setting_Id"
              v-bind:id="
                'choice' +
                  choice.Choice +
                  '-' +
                  settingInput.setting.Behavior_Setting_Id
              "
              v-bind:value="choice.Choice"
              v-model="
                settingInput.inputs.find(i => i.order == input.Order).input
              "
            />{{ choice.Choice }} - {{ choice.Text }}
          </label>
        </div>
      </div>
      <!-- yes/no explain -->
      <div
        v-if="
          input.Score_Template_Input_Type_Id == 5 ||
            (input.Score_Template_Input_Type != null &&
              input.Score_Template_Input_Type.Score_Template_Input_Type_Id == 5)
        "
        class="form-group"
      >
        <label class="mr-4">{{ input.Request }}</label>
        <div class="d-inline-block">
          <label
            class="btn btn-sm"
            v-bind:for="'yes' + settingInput.setting.Behavior_Setting_Id"
            v-bind:class="{
              'btn-primary': settingInput.inputs.find(
                i => i.order == input.Order
              ).input.Occured,
              'btn-outline-primary': !settingInput.inputs.find(
                i => i.order == input.Order
              ).input.Occured
            }"
          >
            <input
              style="display: none"
              type="radio"
              v-bind:id="'yes' + settingInput.setting.Behavior_Setting_Id"
              v-bind:name="'yesno' + settingInput.setting.Behavior_Setting_Id"
              v-bind:value="true"
              v-model="
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured
              "
            />Yes
          </label>
          <label
            class="btn btn-sm ml-2"
            v-bind:for="'no' + settingInput.setting.Behavior_Setting_Id"
            v-bind:class="{
              'btn-primary':
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured == false,
              'btn-outline-primary':
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured ||
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured == null
            }"
          >
            <input
              style="display: none"
              type="radio"
              v-bind:id="'no' + settingInput.setting.Behavior_Setting_Id"
              v-bind:value="false"
              v-model="
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured
              "
            />No
          </label>
        </div>

        <label
          class="d-block"
          v-bind:for="'explain' + settingInput.setting.Behavior_Setting_Id"
          >Explain:</label
        >
        <textarea
          class="form-control"
          rows="3"
          v-bind:id="'explain' + settingInput.setting.Behavior_Setting_Id"
          v-model="
            settingInput.inputs.find(i => i.order == input.Order).input.Explain
          "
          v-on:change="inputDataChange(input, settingInput)"
          v-bind:required="
            settingInput.inputs.find(i => i.order == input.Order).input.Occured
          "
        />
      </div>
      <!-- Text Response -->
      <div
        v-if="
          input.Score_Template_Input_Type_Id == 6 ||
            (input.Score_Template_Input_Type != null &&
              input.Score_Template_Input_Type.Score_Template_Input_Type_Id == 6)
        "
        class="form-group"
      >
        <label v-bind:for="'text' + settingInput.setting.Behavior_Setting_Id">{{
          input.Request
        }}</label>
        <input
          type="text"
          class="form-control"
          v-bind:id="'text' + settingInput.setting.Behavior_Setting_Id"
          v-model="settingInput.inputs.find(i => i.order == input.Order).input"
          v-on:change="inputDataChange(input, settingInput)"
          required
        />
      </div>
      <!-- yes/no -->
      <div
        v-if="
          input.Score_Template_Input_Type_Id == 7 ||
            (input.Score_Template_Input_Type != null &&
              input.Score_Template_Input_Type.Score_Template_Input_Type_Id == 7)
        "
        class="form-group"
      >
        <label class="mr-4">{{ input.Request }}</label>
        <div class="d-inline-block">
          <label
            class="btn btn-sm"
            v-bind:for="'yes' + settingInput.setting.Behavior_Setting_Id"
            v-bind:class="{
              'btn-primary': settingInput.inputs.find(
                i => i.order == input.Order
              ).input.Occured,
              'btn-outline-primary': !settingInput.inputs.find(
                i => i.order == input.Order
              ).input.Occured
            }"
          >
            <input
              style="display: none"
              type="radio"
              v-bind:id="'yes' + settingInput.setting.Behavior_Setting_Id"
              v-bind:name="'yesno' + settingInput.setting.Behavior_Setting_Id"
              v-bind:value="true"
              v-model="
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured
              "
            />Yes
          </label>
          <label
            class="btn btn-sm ml-2"
            v-bind:for="'no' + settingInput.setting.Behavior_Setting_Id"
            v-bind:class="{
              'btn-primary':
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured == false,
              'btn-outline-primary':
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured ||
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured == null
            }"
          >
            <input
              style="display: none"
              type="radio"
              v-bind:id="'no' + settingInput.setting.Behavior_Setting_Id"
              v-bind:name="'yesno' + settingInput.setting.Behavior_Setting_Id"
              v-bind:value="false"
              v-model="
                settingInput.inputs.find(i => i.order == input.Order).input
                  .Occured
              "
            />No
          </label>
        </div>
      </div>
      <!-- number score -->
      <div v-if="input.Score_Template_Input_Type_Id == 8 ||
            (input.Score_Template_Input_Type != null &&
              input.Score_Template_Input_Type.Score_Template_Input_Type_Id == 8)" class="form-group">
        <label v-bind:for="'score' + settingInput.setting.Behavior_Setting_Id"
          >{{ input.Request }} (Numeric Score)</label
        >
        <input
          type="text"
          class="form-control"
          v-bind:id="'score' + settingInput.setting.Behavior_Setting_Id"
          v-model="settingInput.inputs.find(i => i.order == input.Order).input"
          v-on:change="inputDataChange(input, settingInput)"
          required
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    SettingInputs: Array,
    Input: Object
  },
  data() {
    return {
      settingInputs: [],
      input: null
    };
  },
  mounted() {
    $(document).on("click", "input[type=text]", function() {
      this.select();
    });
    $(document).on("click", "input[type=number]", function() {
      this.select();
    });
    this.settingInputs = this.SettingInputs;
    this.input = this.Input;
    if (typeof this.Input.Input_Data == "string") {
      this.input.Input_Data = JSON.parse(this.Input.Input_Data);
    }
  },
  methods: {
    inputDataChange(input, settingInput) {
      this.$emit("input-change", input, settingInput);
    },
    checkMax(settingInput, maxScore) {
      if (settingInput.input > maxScore) {
        settingInput.input = maxScore;
      }
    },
    convertToPercentage(settingInput) {
      if (settingInput.input.includes("/")) {
        var splitInput = settingInput.input.split("/");
        if (splitInput.length == 2) {
          settingInput.input = (
            (parseFloat(splitInput[0]) / parseFloat(splitInput[1])) *
            100
          ).toFixed(2);
        }
      }
    }
  }
};
</script>
